// import { useRef } from "react";
import ImgTag from "@/components/Helpers/ImgTag";
import CloseIcon from "@/components/icons/CloseIcon";
import { Fragment } from "react";
// import { t } from "i18next";
// function getNextMonthIndex(currentMonthIndex) {
//   let nextMonthIndex = currentMonthIndex + 2;

//   if (nextMonthIndex <= 12) {
//     return nextMonthIndex;
//   } else if (nextMonthIndex === 13) {
//     return 0; // January
//   } else if (nextMonthIndex === 14) {
//     return 1; // February
//   }
// }

const MadfuWidgetModal = ({ t, locale, show, setShow }) => {
  const options = [
    {
      "title-ar": "الشريعه السمحة:",
      "title-en": "The Gracious Sharia:",

      "desc-ar": "لا فوائد, ولا رسوم تأخير, ولا تكاليف مخفية",
      "desc-en": "No interest, no late fees, and no hidden costs.",
      img: "shariah-compliant",
    },
    {
      "title-ar": "معلومات البطاقة اّمنة بنسبة 100%:",
      "title-en": "Fill in your details",

      "desc-ar": "تنفيذ أمان قوي وحماية.",
      "desc-en": "Implementation of strong security and protection.",
      img: "cards-secure",
    },
    {
      "title-ar": "استمتع الاّن, وادفع لاحقا:",
      "title-en": "Select MADFU at checkout",

      "desc-ar": "بدون فوائد, وبدون رسوم تأخير, وبدون تكاليف مخفية",
      "desc-en":
        "Without interest, without late fees, and without hidden costs.",
      img: "pay-later",
    },
  ];

  return (
    <Fragment>
      {show ? (
        <div className="text-center overflow-x-hidden p-8 w-screen max-[768px]:w-[90vw] max-[991px]:w-8/12 max-w-[800px] max-[991px]:max-h-[70vh] overflow-auto max-[768px]:h-[80vh] shadow-lg max-[991px]:h-[614px] rounded-xl fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[999999] bg-gray-100 flex flex-col gap-6 items-center justify-center max-[991px]:justify-between">
          <CloseIcon
            onClick={() => setShow(false)}
            className="absolute cursor-pointer start-4 top-4"
          />
          <p className=" mt-10 mx-4 text-lg text-start max-[991px]:text-center border-b-[0.5px] border-gray-300 pb-5 w-full">
            <span className="font-bold">{t("Split into Payments")}</span>{" "}
            <span>{t("Split up to 6 Payments")}</span>
          </p>
          {false && <p className="mx-4 text-lg text-start max-[991px]:text-center border-b-[0.5px] border-gray-300 pb-5 w-full">
            <span className="font-bold">{t("Monthly payments")}</span>{" "}
            <span>{t("With no interest, no late fees & no hidden costs")}</span>
          </p>}
          <div className="w-full bg-gray-100">
            <div className="grid grid-cols-3 gap-6 mt-4 max-[991px]:grid-cols-1">
              {options?.map((opt, i) => (
                <div
                  key={opt.icon || i}
                  className="flex flex-col items-start max-[991px]:items-center gap-3"
                >
                  <ImgTag
                    loading="eager"
                    priority="high"
                    src={`/imgs/madfu/new/${opt.img}.png`}
                    alt={opt["title-" + locale]}
                    className="object-contain h-20"
                  />
                  <p className="text-start text-base font-bold">
                    {opt["title-" + locale]}
                  </p>

                  <p className="text-start text-sm -mt-2">
                    {opt["desc-" + locale]}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default MadfuWidgetModal;
